import imageField from 'molecules/Image/config';
import sectionFields from 'molecules/Section/config';

import type { Component, Input } from '@builder.io/sdk';

const connectHeroFields = [
  {
    name: 'eyebrow',
    type: 'string',
    defaultValue: 'JOIN US',
    helperText: 'Short label above the heading (e.g. "JOIN US").',
  },
  {
    name: 'heading',
    type: 'string',
    defaultValue: 'Prismatic Connect 2026',
    helperText: 'Main heading text.',
  },
  {
    name: 'body',
    type: 'longText',
    helperText: 'Intro paragraph shown below the heading.',
  },
  {
    name: 'bullets',
    type: 'list',
    helperText: 'Short highlight items, each shown with a teal accent bar.',
    subFields: [
      { name: 'id', type: 'string', required: true, showIf: 'false' },
      {
        name: 'text',
        type: 'string',
        required: true,
        defaultValue: 'Highlight',
        helperText: 'Bold lead-in for the highlight (e.g. "Learn to build faster").',
      },
      {
        name: 'description',
        type: 'string',
        helperText: 'Optional supporting text shown after the bold lead-in.',
      },
    ],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange: (options: Map<string, any>) => {
      options.get('bullets').forEach((item: Map<string, string>, index: number) => {
        item.set('id', `bullet-${index}`);
      });
    },
  },
  {
    ...imageField('image'),
    helperText: 'Hero image (the full composition is a single uploaded image).',
  },
  {
    name: 'reverse',
    type: 'boolean',
    defaultValue: false,
    helperText: 'Swap the image and text sides on desktop (the image stays on top on mobile).',
  },
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const connectHeroConfig = {
  name: 'ConnectHero',
  inputs: connectHeroFields,
} satisfies Component;

export type ConnectHeroConfigProps = GenerateBuilder<typeof connectHeroFields>;

export default connectHeroConfig;
